// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3294e","label":"Category_label__1gA4p","content":"Category_content__YnFc6","header":"Category_header__gdiAD","location":"Category_location__2qp8J"};